"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AllCountryOption = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AllCountryOption = function AllCountryOption(_ref) {
  var label = _ref.label,
      iso2 = _ref.iso2,
      visa = _ref.visa,
      budget = _ref.budget,
      closed = _ref.closed;
  return /*#__PURE__*/_react["default"].createElement(CountryItem, {
    $closed: closed
  }, /*#__PURE__*/_react["default"].createElement(_styles.TitleBlock, null, /*#__PURE__*/_react["default"].createElement(FlagContainer, null, /*#__PURE__*/_react["default"].createElement(StyledFlag, {
    className: "lt-flag lt-flag-".concat(iso2 === null || iso2 === void 0 ? void 0 : iso2.toLowerCase())
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(CountryLabelText, null, label), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_styles.SubtitleBlock, {
    $active: visa !== 'Без визы'
  }, visa), /*#__PURE__*/_react["default"].createElement(_styles.SubtitleBlock, null, '$'.repeat(budget))))));
};

exports.AllCountryOption = AllCountryOption;

var CountryItem = _styledComponents["default"].div.withConfig({
  displayName: "AllCountryOption__CountryItem",
  componentId: "sc-1weoqff-0"
})(["padding-top:4px;", ""], function (_ref2) {
  var $closed = _ref2.$closed;
  return $closed && "\n    opacity: 0.3;\n  ";
});

var CountryLabelText = _styledComponents["default"].div.withConfig({
  displayName: "AllCountryOption__CountryLabelText",
  componentId: "sc-1weoqff-1"
})(["font-size:16px;line-height:20px;"]);

var FlagContainer = _styledComponents["default"].div.withConfig({
  displayName: "AllCountryOption__FlagContainer",
  componentId: "sc-1weoqff-2"
})(["height:20px;display:flex;align-items:center;"]);

var StyledFlag = _styledComponents["default"].div.withConfig({
  displayName: "AllCountryOption__StyledFlag",
  componentId: "sc-1weoqff-3"
})(["margin:0 8px;"]);